import {
    useEffect,
    useState,
} from 'react';

// Delay a value until it has stopped changing for `delay` ms.
//
// The availability check runs as the user types a base name, and each run is
// four listings — one of which drains every pipeline in the account. Firing
// that per keystroke is what this exists to prevent.
//
// ⚠️ `initial` seeds the first render, and defaults to the EMPTY value rather
// than to `value`. Seeding with `value` would make the very first render count
// as settled, so a mount with a pre-filled field fires the check immediately
// and the first keystroke after it fires a second — the debounce would start
// working only from the second character onwards.
export const useDebouncedValue = <T, >(value: T, delay: number, initial: T): T => {
    const [debounced, setDebounced] = useState(initial);

    useEffect(() => {
        const timer = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(timer);
    }, [value, delay]);

    return debounced;
};
